/* eslint-disable */
import Hammer from 'hammerjs';
class HammerMock{

}
class Manager {
	constructor(a, b) {

	}
	add() {

	}
	on(){

	}
}
HammerMock.Manager = Manager

let clazz;
if (typeof window !== "undefined") {
	clazz = Hammer;
} else {
	clazz = HammerMock;
}



export default clazz;

